<ng-container *ngIf="isLoaded()">
  <!-- Formularios en tarea o en modal sin wrapper -->
  <ng-container *ngIf="(task || windowHash); else templateWrapper">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-container>
  <!-- <ng-template #templateBase>
    <ng-container *ngIf="windowHash; else templateWrapper">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </ng-container>
  </ng-template> -->
  <ng-template #templateWrapper>
    <div class="wrapper wrapper-content BASEFORMINMODAL" *ngIf="!windowHash">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </div>
  </ng-template>
  <ng-template #formTemplate>
    <!-- COMENTARIO DE RECHAZO PARA FORMULARIOS QUE GESTIONAN DOCUMENTOS -->
    <div #rejectionPanelContainer></div>
    <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig"></formPlyca>
  </ng-template>
</ng-container>
<ng-template #profilesTemplate>
  <h1>Signers</h1>
  <span>asdfglkasdñf</span>
</ng-template>